import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";



const AuctionsList = Loadable(
    lazy(() =>
        import("./AuctionsList").then(({ AuctionsList }) => ({
            default: AuctionsList,
        }))
    )
);

const ManageAuction = Loadable(
    lazy(() =>
        import("./ManageAuction").then(({ ManageAuction }) => ({
            default: ManageAuction,
        }))
    )
);

const AuctionsProductsList = Loadable(
    lazy(() =>
        import("./AuctionsProductsList").then(({ AuctionsProductsList }) => ({
            default: AuctionsProductsList,
        }))
    )
);

const ManageAuctionProduct = Loadable(
    lazy(() =>
        import("./ManageAuctionProduct").then(({ ManageAuctionProduct }) => ({
            default: ManageAuctionProduct,
        }))
    )
);


const AuctionsProductsLinkList = Loadable(
    lazy(() =>
        import("./AuctionProductLinkList").then(({ AuctionsProductsLinkList }) => ({
            default: AuctionsProductsLinkList,
        }))
    )
);


const ManageAuctionLinkedProduct = Loadable(
    lazy(() =>
        import("./ManageAuctionLinkedProduct").then(({ ManageAuctionLinkedProduct }) => ({
            default: ManageAuctionLinkedProduct,
        }))
    )
);

export const auctionsRoutes = [
    {
        path: "/auctions-list",
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess
                moduleIds={[]}
            >
                <AuctionsList />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/auctions-list/manage",
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess
                moduleIds={[]}
            >
                <ManageAuction />
            </AuthorizedRoute>
        ),
    },
    {
        path: "/auctions-list/manage/:uuid",
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess
                moduleIds={[]}
            >
                <ManageAuction />
            </AuthorizedRoute>
        ),
    },
      {
        path: "/auctions-products-list",
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess
                moduleIds={[]}
            >
                <AuctionsProductsList />
            </AuthorizedRoute>
        ),
    },
     {
        path: "/auctions-products-list/manage",
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess
                moduleIds={[]}
            >
                <ManageAuctionProduct />
            </AuthorizedRoute>
        ),
    },
     {
        path: "/auctions-products-list/manage/:uuid",
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess
                moduleIds={[]}
            >
                <ManageAuctionProduct />
            </AuthorizedRoute>
        ),
    },
     {
        path: "/auctions-linked-products-list",
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess
                moduleIds={[]}
            >
               <AuctionsProductsLinkList/>
            </AuthorizedRoute>
        ),
    },
     {
        path: "/auctions-linked-products-list/manage/",
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess
                moduleIds={[]}
            >
           <ManageAuctionLinkedProduct/>   
            </AuthorizedRoute>
        ),
    },

      {
        path: "/auctions-linked-products-list/manage/:uuid",
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess
                moduleIds={[]}
            >
              <ManageAuctionLinkedProduct/>
            </AuthorizedRoute>
        ),
    },
];
